

export const ScheduleNotification = (values) => {
    let errors = {};

    if (!values?.title) {
        errors.title = 'Title field is required'
    }

    if (!values?.desc) {
        errors.desc = 'Description field is required'
    }

    if (!values?.leadTime) {
        errors.leadTime = 'Lead Time is required'
    }

    if (!values?.method) {
        errors.method = 'Method is required'
    }


    return errors;
};

export const BroadCastNotification = (values) => {
    let errors = {};

    if (!values?.title?.trim()) {
        errors.title = 'Title field is required'
    }

    if (values?.title?.trim() && (values?.title?.length < 3 || values?.title?.length > 100)) {
        errors.title = 'Title must be between 3 and 100 characters'
    }

    if (!values?.desc?.trim()) {
        errors.desc = 'Description field is required'
    }

    if (values?.desc?.trim() && (values?.desc?.length < 3 || values?.desc?.length > 1080)) {
        errors.desc = 'Description must be between 3 and 1080 characters'
    }

    if (!values?.type) {
        errors.type = 'Type is required'
    }

    if (!values?.method) {
        errors.method = 'Method is required'
    }

    if (Number(values?.isScheduled) === 1 && !values.scheduleTime) {
        errors.scheduleTime = 'Please add schedule time'
    }

    if (Number(values?.isScheduled) === 1 && values.scheduleTime) {
        if (new Date(values.scheduleTime) < new Date()) {
            errors.scheduleTime = 'Please enter a valid date';
        }
    }

    if (values.type === 'selectedUser' && !(values?.userId?.length > 0)) {
        errors.userId = 'Please select user'
    }

    return errors;
};

export const instrumentValidation = (values) => {
    let errors = {};

    if (!values?.name?.trim()) {
        errors.name = 'name field is required'
    }

    if (values?.name?.trim() && (values?.name?.length < 2 || values?.name?.length > 50)) {
        errors.name = 'name must be between 2 and 50 characters'
    }

    return errors;
};